// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"5":"59fd1877","806":"caaac2de"}[chunkId] + ".chunk.js";
};